function defineErrorCodes(codes) {
  return codes;
}

export { defineErrorCodes };
